import Marketplace from "./marketplace.container";

export default Marketplace;
